import { X } from "phosphor-react";
import speakerBg from "../../../assets/REMA/speakers/speakerBg.svg";
import ReactModal from "react-modal";

const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: 0,
    borderRadius: "0px",
    maxWidth: "100vw",
    width: "1240px",
    maxHeight: "100dvh",
    overflowY: "auto",
    border: "none",
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.75)",
    zIndex: 1000,
  },
};

const SpeakerBioModal = ({ speaker, isOpen, onClose }) => {
  if (!speaker) return null;

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={modalStyles}
      contentLabel={`Full Bio of ${speaker.name}`}
    >
      <div className="p-6 py-12 md:p-12 lg:max-h-[690px] flex bg-[#11302D] flex-col lg:flex-row gap-10  h-screen overflow-y-auto lg:overflow-y-hidden">
        <button
          className="absolute top-4 right-4 w-9 h-9 bg-[#CBF07F] text-[#082421] flex items-center justify-center self-end"
          onClick={onClose}
        >
          <X size={24} weight="bold" />
        </button>
        <div className="aspect-[313/309] md:aspect-[445/590] max-h-[309px] h-[400px] md:h-[480px] md:max-h-[480px] lg:max-h-max lg:h-auto  relative">
          <div className="absolute top-0 left-0 h-full w-full ">
            <img
              src={speakerBg}
              alt="Speaker Background"
              className="w-full h-full object-cover"
            />
          </div>
          <img
            src={speaker.image}
            alt={speaker.name}
            className="h-full w-full object-top object-cover transform grayscale"
          />
        </div>
        <div className="flex-1 space-y-5 text-white font-sora lg:overflow-y-auto">
          <div>
            <h3 className="font-semibold text-[24px] xl:text-[52px] leading-tight mb-2">
              {speaker.name}
            </h3>
            <p className=" text-base font-medium italic mb-2 text-[#CBF07F]">
              {speaker.title}
            </p>
          </div>
          <div className="h-px bg-[#CBF07F] w-full opacity-20" />
          <p
            className="text-[#CBF07F] text-[24px] xl:text-[40px] font-semibold tracking-[-2%]"
            style={{ textWrap: "balance" }}
          >
            "{speaker.sessionTitle}"
          </p>
          <p className="font-inter leading-loose flex-1 whitespace-pre-line">
            {speaker.fullBio ||
              "Detailed biography is currently unavailable for this speaker."}
          </p>
        </div>
      </div>
    </ReactModal>
  );
};

export default SpeakerBioModal;
